// src/components/RejectModal.js
import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const RejectModal = ({ show, onHide, onSubmit }) => {
  const [reason, setReason] = useState('');

  const handleSubmit = () => {
    onSubmit(reason);
    setReason('');
  };

  const handleClose = () => {
    setReason('');
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Reject Assignment</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="rejectionReason">
            <Form.Label>Please provide a reason for rejection:</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Enter rejection reason"
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleSubmit} disabled={!reason.trim()}>
          Reject Assignment
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RejectModal;
